import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=2dec25ae"
var script = {}
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=2dec25ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports